export default __webpack_public_path__ + "static/media/slider_image_01-lg@1x.6847e74c.jpg";